/**
 * Footer component behaviors.
 *
 * Revela elementos marcados com [data-deferred-ui] (ex: WhatsApp flutuante,
 * barra de CTA fixa) apos o carregamento, evitando que apareçam antes do
 * layout estabilizar.
 *
 * @param {Document} root
 */
export function initFooter(root = document) {
  // Mapa do site — recolhe/expande as listas ao clicar no titulo.
  const sitemapToggle = root.querySelector("[data-sitemap-toggle]");
  const sitemap = root.getElementById
    ? root.getElementById("footer-sitemap")
    : document.getElementById("footer-sitemap");

  if (sitemapToggle && sitemap) {
    sitemapToggle.addEventListener("click", () => {
      const isExpanded = sitemapToggle.getAttribute("aria-expanded") === "true";
      sitemapToggle.setAttribute("aria-expanded", isExpanded ? "false" : "true");
      sitemap.classList.toggle("is-collapsed", isExpanded);
    });
  }

  // Voltar para o topo — rola suavemente ate o inicio da pagina.
  const backTop = root.querySelector(".footer__back-top");

  if (backTop) {
    backTop.addEventListener("click", (event) => {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  const whatsappWidget = root.querySelector("[data-whatsapp-widget]");
  const whatsappToggle = root.querySelector("[data-whatsapp-toggle]");
  const whatsappPanel = root.querySelector("[data-whatsapp-panel]");

  const setWhatsappOpen = (open) => {
    if (!whatsappWidget || !whatsappToggle || !whatsappPanel) {
      return;
    }

    if (open) {
      whatsappWidget.hidden = false;
    }

    whatsappWidget.classList.toggle("is-open", open);
    whatsappToggle.setAttribute("aria-expanded", open ? "true" : "false");
    whatsappPanel.setAttribute("aria-hidden", open ? "false" : "true");
  };

  if (whatsappWidget && whatsappToggle && whatsappPanel) {
    whatsappToggle.addEventListener("click", (event) => {
      event.stopPropagation();
      setWhatsappOpen(!whatsappWidget.classList.contains("is-open"));
    });

    whatsappWidget.addEventListener("click", (event) => {
      event.stopPropagation();
    });

    root.querySelectorAll("[data-whatsapp-popup-trigger]").forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        setWhatsappOpen(true);
      });
    });

    document.addEventListener("click", () => setWhatsappOpen(false));
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        setWhatsappOpen(false);
      }
    });
  }

  const deferredUi = root.querySelectorAll("[data-deferred-ui]");

  if (!deferredUi.length) {
    return;
  }

  const revealDeferredUi = () => {
    deferredUi.forEach((element) => {
      element.hidden = false;
    });
  };

  const scheduleDeferredUiReveal = () => {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(revealDeferredUi, { timeout: 1500 });
      return;
    }

    window.setTimeout(revealDeferredUi, 900);
  };

  if (document.readyState === "complete") {
    scheduleDeferredUiReveal();
    return;
  }

  window.addEventListener("load", scheduleDeferredUiReveal, { once: true });
}
